var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6086 4.76909C21.5504 5.02293 22.2936 5.76607 22.5474 6.70788V6.71155C23.0183 8.43329 22.9999 12.0202 22.9999 12.0202C22.9999 12.0202 22.9999 15.5888 22.5474 17.3105C22.2936 18.2523 21.5504 18.9954 20.6086 19.2493C18.8869 19.7018 12 19.7018 12 19.7018C12 19.7018 5.13142 19.7018 3.39129 19.2309C2.44949 18.9771 1.70635 18.2339 1.45251 17.2921C1 15.5888 1 12.0018 1 12.0018C1 12.0018 1 8.42961 1.45251 6.70788C1.70635 5.76607 2.46789 5.00454 3.39129 4.75069C5.11303 4.29819 12 4.29819 12 4.29819C12 4.29819 18.8869 4.29819 20.6086 4.76909ZM9.46204 15.6958V8.30471V8.30059L15.8803 11.9982L9.46204 15.6958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.e864f0fd2b6561d297331d7afcd2b828.svg";
export { ForwardRef as ReactComponent };